import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ContentIcon from '../ContentIcon/index.js';
import Tooltip from '../Tooltip/index.js';
import { bgStyles, calcTitleClassNames } from './progressIconStyles.js';

function ProgressIcon({
  content,
  user,
  pos,
  bgColor,
  vertical,
  labels,
  size,
  locks
}) {
  const iconSize = vertical ? "small" : size;
  const bgStyle = bgStyles(bgColor, pos, vertical);
  const titleClassNames = calcTitleClassNames(pos, vertical);
  const containerClassNames = vertical ? "slds-grid slds-grid_vertical-align-center" : "slds-text-align_center";
  const iconContainerClassNames = vertical ? "slds-m-right_small slds-shrink-none" : "";
  const bgClassNames = cx("tds-border-radius_round slds-p-around_xx-small tds-progress-icon__background slds-show_inline-block", {
    "slds-p-around_small": iconSize !== "small"
  });
  const isFinished = user.finishedAt;
  const renderIcon = () => /*#__PURE__*/React.createElement("div", {
    className: `${containerClassNames} tds-progress-icon`
  }, /*#__PURE__*/React.createElement("div", {
    style: bgStyle,
    className: iconContainerClassNames
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      border: `2px solid ${bgColor}`,
      backgroundColor: bgColor
    },
    className: bgClassNames
  }, /*#__PURE__*/React.createElement(ContentIcon, {
    content: content,
    user: user,
    size: iconSize,
    noLink: true,
    locks: locks
  }))), /*#__PURE__*/React.createElement("div", {
    className: titleClassNames
  }, content.title));
  if (size !== "small") {
    return renderIcon();
  }
  if (isFinished) {
    return /*#__PURE__*/React.createElement("a", {
      href: content.path
    }, renderIcon());
  }
  if (!locks) {
    return /*#__PURE__*/React.createElement("a", {
      href: content.path,
      "aria-describedby": `${content.apiName}-tooltip`
    }, renderIcon());
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    align: "top",
    content: labels.unlockSuperbadge,
    triggerClassName: "tds-display_block",
    position: "absolute",
    id: `${content.apiName}-tooltip`
  }, /*#__PURE__*/React.createElement("a", {
    href: content.path,
    "aria-describedby": `${content.apiName}-tooltip`
  }, renderIcon()));
}
ProgressIcon.displayName = "ProgressIcon";
ProgressIcon.defaultProps = {
  user: {},
  bgColor: null,
  vertical: false,
  size: "small",
  locks: true
};
ProgressIcon.propTypes = {
  content: PropTypes.shape({
    color: PropTypes.string,
    image: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    apiName: PropTypes.string
  }).isRequired,
  user: PropTypes.shape({
    finishedAt: PropTypes.string
  }),
  pos: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  vertical: PropTypes.bool,
  labels: PropTypes.shape({
    unlockSuperbadge: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  size: PropTypes.string,
  locks: PropTypes.bool
};

export { ProgressIcon as default };
